import React from "react";
import VTSell from "../page/VTSell";

export default function LandingSellVT({page}) {
    return (
        <>
            <VTSell/>
        </>
    );
}